import React from "react";

export const FailureModeBadge: React.FC<{ mode: string }> = ({ mode }) => {
  if (!mode || mode === "none" || mode === "unset") {
    return <span className="al-text-gray-400">-</span>;
  }

  const colorMap: Record<string, string> = {
    tests_failed: "al-bg-orange-100 al-text-orange-700",
    timeout: "al-bg-yellow-100 al-text-yellow-700",
    error: "al-bg-red-100 al-text-red-700",
    agent_error: "al-bg-red-100 al-text-red-700",
  };

  const colorClass = colorMap[mode] || "al-bg-gray-100 al-text-gray-700";

  return <span className={`al-px-2 al-py-0.5 al-rounded al-text-xs ${colorClass}`}>{mode}</span>;
};
